import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

import { NeuteredEnum } from '@src/components/Forms/PatientInformation/PatientInformation.helpers';

type PatientInformationState = {
	species: string;
	petName: string;
	sex: string;
	neutered: NeuteredEnum | string;
	birthDate: Date | null;
	isEstimatedAge: boolean;
	breed: string;
	color: string;
	patientId: string;
	vendorAppointmentId: string;
	notes: Record<string, any>;
	checkInLink: string;
};

type PatientInformationActions = {
	setSpecies: (species: string) => void;
	setPetName: (petName: string) => void;
	setSex: (sex: string) => void;
	setNeutered: (spayed: string) => void;
	setBirthDate: (birthDate: Date) => void;
	setIsEstimatedAge: (isEstimatedAge: boolean) => void;
	setBreed: (breed: string) => void;
	setColor: (color: string) => void;
	setPatientId: (patientId: string) => void;
	setVendorAppointmentId: (vendorAppointmentId: string) => void;
	setNotes: (notes: Record<string, any>) => void;
	setCheckInLink: (checkInLink: string) => void;
};

const usePatientInformationStore = create<PatientInformationState & PatientInformationActions>((set) => ({
	species: '',
	setSpecies: (species) => set({ species }),
	petName: '',
	setPetName: (petName) => set({ petName }),
	sex: '',
	setSex: (sex) => set({ sex }),
	neutered: '',
	setNeutered: (neutered) => set({ neutered }),
	birthDate: null,
	setBirthDate: (birthDate) => set({ birthDate }),
	isEstimatedAge: false,
	setIsEstimatedAge: (isEstimatedAge) => set({ isEstimatedAge }),
	breed: '',
	setBreed: (breed) => set({ breed }),
	color: '',
	setColor: (color) => set({ color }),
	patientId: '',
	setPatientId: (patientId) => set({ patientId }),
	vendorAppointmentId: '',
	setVendorAppointmentId: (vendorAppointmentId) => set({ vendorAppointmentId }),
	notes: {},
	setNotes: (notes) => set({ notes }),
	checkInLink: '',
	setCheckInLink: (checkInLink) => set({ checkInLink }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('usePatientInformationStore', usePatientInformationStore);
}

export default usePatientInformationStore;
